import { useParams } from 'react-router-dom';

import { AppUpdateLiveStreamPage } from '~/components/pages/AppUpdateLiveStreamPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppUpdateLiveStreamRoute: React.FC = () => {
  const { appId, liveStreamId } = useParams();
  const navigate = useNavigate();

  if (!appId) {
    navigate('/');

    return null;
  }

  if (!liveStreamId) {
    navigate(`/apps/${appId}/liveStreams`);

    return null;
  }

  return (
    <DashboardTemplate appId={appId} noAppPreviewOverlap>
      <AppUpdateLiveStreamPage appId={appId} liveStreamId={liveStreamId} />
    </DashboardTemplate>
  );
};
